import { Box, Typography, Button, Card, CardContent, List, ListItem, ListItemIcon, ListItemText, Stack, Divider } from "@mui/material";
import { ElementType } from "react";
import ScienceIcon from '@mui/icons-material/Science';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

interface ConfirmProps {
    setConfirmed: (confirmed: boolean) => void;
}

const Confirm: ElementType<ConfirmProps> = ({ setConfirmed }) => {
    const handleConfirm = () => {
        setConfirmed(true);
    };

    const handleReject = () => {
        window.location.href = 'https://myhelpers.app';
    };

    return (
        <Box sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            maxWidth: 900,
            mx: 'auto',
        }}>
            <ScienceIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
            
            <Typography component="h1" variant="h4" gutterBottom fontWeight={600}>
                Join Our Beta Adventure! 🚀
            </Typography>

            <Typography variant="body1" color="text.secondary" textAlign="center" sx={{ mb: 4 }}>
                Thanks for your interest in Helpers! Before you sign up, here's what you should know about our beta testing phase.
            </Typography>

            <Card sx={{ width: '100%', mb: 3 }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom fontWeight={600} color="primary">
                        What to Expect
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <HourglassEmptyIcon color="warning" />
                            </ListItemIcon>
                            <ListItemText
                                primary="Admin Approval Required"
                                secondary="Your registration will need activation before you can dive in. We'll review it as quickly as possible!"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <InfoOutlinedIcon color="info" />
                            </ListItemIcon>
                            <ListItemText
                                primary="Intermittent Availability"
                                secondary="Some services (especially our AI inference engine) might not be running 24/7 - they're a bit pricey to keep on all the time. Thanks for understanding!"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <ScienceIcon color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="Beta Tester Perks"
                                secondary="You'll get early access to new features and help shape the future of Helpers. Your feedback is gold to us!"
                            />
                        </ListItem>
                    </List>
                </CardContent>
            </Card>

            <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mb: 3 }}>
                Ready to be part of our beta testing journey?
            </Typography>

            <Stack direction="row" spacing={2} width="100%">
                <Button
                    fullWidth
                    variant="outlined"
                    onClick={handleReject}
                    size="large"
                >
                    Maybe Later
                </Button>
                <Button
                    fullWidth
                    variant="contained"
                    onClick={handleConfirm}
                    size="large"
                >
                    I'm In! Let's Go
                </Button>
            </Stack>
        </Box>
    );
}

export default Confirm;